import { Directive, EventEmitter, HostListener, Input, Output } from "@angular/core";
import { BpInputComponent } from "@modules/core/components/bp-input/bp-input.component";

@Directive({
	selector: "[bpInputNumberLeadingTrailingDot]",
	standalone: false
})
export class BpInputNumberLeadingTrailingDot {
	@Input() trailingDotPrecision = 2;
	@Output() keydownEnter = new EventEmitter<void>();

	constructor(private bpInput: BpInputComponent) {}

	@HostListener("focusout", ["$event.target.value"])
	public onFocusout(value: string | undefined): void {
		this.setBpInputValue(value);
	}

	@HostListener("keydown.enter", ["$event.target.value"])
	public onKeydownEnter(value: string | undefined): void {
		this.setBpInputValue(value);
		this.keydownEnter.emit();
	}

	private setBpInputValue(value: string | undefined): void {
		if (value?.startsWith(".")) {
			this.bpInput._value = "0" + value;
		}

		if (value?.endsWith(".")) {
			this.bpInput._value = value + "0".repeat(this.trailingDotPrecision);
		}
	}
}
